<!-- Messages toggle -->
<button
    mat-icon-button
    (click)="openPanel()"
    #messagesOrigin>
    <ng-container *ngIf="unreadCount > 0">
        <span class="absolute top-0 right-0 left-0 flex items-center justify-center h-3">
            <span class="flex items-center justify-center shrink-0 min-w-4 h-4 px-1 ml-4 mt-2.5 rounded-full bg-indigo-600 text-indigo-50 text-xs font-medium">
                {{unreadCount}}
            </span>
        </span>
    </ng-container>
    <mat-icon [svgIcon]="'heroicons_outline:inbox'"></mat-icon>
</button>

<!-- Messages panel -->
<ng-template #messagesPanel>

    <div class="fixed inset-0 sm:static sm:inset-auto flex flex-col sm:min-w-90 sm:w-90 sm:rounded-2xl overflow-hidden shadow-lg">

        <!-- Header -->
        <div class="flex shrink-0 items-center py-4 pr-4 pl-6 bg-primary text-on-primary">
            <div class="sm:hidden -ml-1 mr-3">
                <button
                    mat-icon-button
                    (click)="closePanel()">
                    <mat-icon
                        class="icon-size-5 text-current"
                        [svgIcon]="'heroicons_solid:x-mark'"></mat-icon>
                </button>
            </div>
            <div class="text-lg font-medium leading-10">Messages</div>
            <div class="ml-auto">
                <button
                    class="dark:text-white"
                    mat-icon-button
                    [disabled]="unreadCount === 0"
                    [matTooltip]="'Mark all as read'"
                    (click)="markAllAsRead()">
                    <mat-icon
                        class="icon-size-5 text-current"
                        [svgIcon]="'heroicons_solid:envelope-open'"></mat-icon>
                </button>
            </div>
        </div>

        <!-- Content -->
        <div class="relative flex flex-col flex-auto sm:max-h-120 divide-y overflow-y-auto bg-card">
            <!-- Messages -->
        <!-- Se la chat è selezionata e ci sono messaggi -->
        <div class="flex flex-col flex-auto border-l overflow-hidden bg-gray-50 dark:bg-transparent">
            <ng-container *ngIf="messages && messages.length > 0; else selectChatOrStartNew">
                <div class="flex flex-col-reverse overflow-y-auto overscroll-y-contain">
                    <div class="flex flex-col flex-auto shrink p-6">
                        <ng-container *ngFor="let message of messages; let i = index; let first = first; let last = last; trackBy: trackByFn">
                            <!-- Start of the day -->
                            <ng-container *ngIf="first || (messages[i - 1].SendDate | date:'d') !== (message.SendDate | date:'d')">
                                <div class="flex items-center justify-center my-3 -mx-6">
                                    <div class="flex-auto border-b"></div>
                                    <div class="flex-0 mx-4 text-sm font-medium leading-5 text-secondary">
                                        {{message.SendDate | date: 'longDate'}}
                                    </div>
                                    <div class="flex-auto border-b"></div>
                                </div>
                            </ng-container>
                            {{message}}
                            <div class="flex flex-col" [ngClass]="{'items-end': message.Sender.value === currentUserId, 'items-start': message.Sender.value !== currentUserId}">
                                <!-- Bubble -->
                                <div class="relative max-w-3/4 px-3 py-2 rounded-lg" [ngClass]="{'bg-my-message ': message.Sender.value === currentUserId, 'bg-gray-500 text-gray-50': message.Sender.value !== currentUserId}">
                                    <div class="min-w-4 leading-5">
                                        {{ message.Content }} <!-- Mostra il contenuto del messaggio -->
                                    </div>
                                </div>
        
                                <!-- Mostra l'orario del messaggio -->
                                <div class="my-0.5 text-sm font-medium text-secondary">
                                    {{ message.SendDate | date:'HH:mm' }}
                                </div>
                            </div>
                        </ng-container>
                    </div>
                </div>
            </ng-container>
        
            <!-- Placeholder when there are no messages -->
            <ng-template #selectChatOrStartNew>
                <div class="flex flex-auto items-center justify-center p-4">
                    <div class="text-xl font-medium tracking-tight text-secondary">No messages in this chat</div>
                </div>
            </ng-template>
        </div>
        

        </div>
    </div>
</ng-template>
